import React from 'react';
import { useTranslation } from 'react-i18next';
import './Services.css';

// Import your background images
import infraBg from '../../assets/images/infra-bg.jpg';
import buildingBg from '../../assets/images/building-bg.jpg';
import landscapeBg from '../../assets/images/landscape-bg.jpg';
import electromechanicalBg from '../../assets/images/electromechanical-bg.jpg';
import roadMaintenanceBg from '../../assets/images/road-maintenance-bg.jpg';
import roadLightingBg from '../../assets/images/road-lighting-bg.jpg';

const Services = () => {
  const { t } = useTranslation();
  const services = t('services.items', { returnObjects: true });

  const backgroundImages = {
    infraBg,
    buildingBg,
    landscapeBg,
    electromechanicalBg,
    roadMaintenanceBg,
    roadLightingBg
  };

  return (
    <section className="services-section" id="services" dir={t('dir')}>
      <div className="vision-header">
        <h2 className="vision-title">{t('services.title')}</h2>
        <div className="vision-divider">
          <span className="divider-line"></span>
          <span className="divider-diamond">◆</span>
          <span className="divider-line"></span>
        </div>
        <p className="vision-subtitle">
          {t('services.subtitle')}
        </p>
      </div>

      <div className='section-container'>
        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="service-card"
              style={{ 
                backgroundImage: `url(${backgroundImages[service.bgImage]})`,
                aspectRatio: service.aspectRatio
              }}
            >
              <div className="card-overlay"></div>
              <h3 className="card-title">{service.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;